export const ORG_TIERS = {
    0: 'Business',
    1: `Health Systems`,
    2: `Hospitals`
};
export const OrgNames = {
    0: 'BUSINESS',
    1: 'HEALTH_SYSTEM',
    2: 'HOSPITAL'
};
const buildServiceMaps = (relationships)=>{
    const map = new Map();
    const now = Date.now();
    relationships.forEach((relationship)=>{
        const ids = relationship.organizationRelationships.filter((orgRel)=>{
            return (orgRel.endDate === null || orgRel.endDate > now) && orgRel.id !== null;
        }).map((orgRel)=>orgRel.toOrganizationId);
        const set = new Set(ids);
        map.set(relationship.name, set);
    });
    return map;
};
const StandardSystemColumns = [
    {
        key: 'displayName',
        displayName: 'Name'
    }
];
const POColumns = [
    ...StandardSystemColumns,
    {
        key: 'serviceLine',
        displayName: 'Service Lines',
        transform: (org)=>{
            // I've overloaded the organization here for convenience purposes
            //@ts-ignore
            const parent = org.parent;
            const activeServiceLines = [];
            if (parent) {
                const serviceMaps = buildServiceMaps(parent.serviceLines ?? []);
                const keys = [
                    ...serviceMaps.keys()
                ];
                keys.forEach((key)=>{
                    const set = serviceMaps.get(key);
                    if (set?.has(org.id)) {
                        activeServiceLines.push(key);
                    }
                });
            }
            return activeServiceLines.join(', ');
        }
    }
];
export const OrgDefs = {
    HOSPITAL: {
        title: 'Hospitals',
        colDefs: StandardSystemColumns
    },
    HEALTH_SYSTEM: {
        title: 'Health Systems',
        colDefs: StandardSystemColumns
    },
    BILLING_ORGANIZATION: {
        title: 'Billing Organizations',
        colDefs: StandardSystemColumns
    },
    PHYSICIAN_ORGANIZATION: {
        title: 'Physician Organization',
        colDefs: POColumns
    }
};
